// src/components/Propuestas/DashboardPropuestas.js
import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Spinner } from 'react-bootstrap';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar, Pie } from 'react-chartjs-2';
import { obtenerIndicadoresPropuestas } from '../../api/common';

ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend);

const ESTADO_COLORS = {
  borrador: '#6c757d',
  enviada: '#0dcaf0',
  vista: '#0d6efd',
  aprobada: '#198754',
  rechazada: '#dc3545',
  cambios_solicitados: '#ffc107',
  vencida: '#fd7e14',
  facturada: '#212529'
};

const DashboardPropuestas = () => {
  const [indicadores, setIndicadores] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    cargarIndicadores();
  }, []);

  const cargarIndicadores = async () => {
    setLoading(true);
    try {
      const response = await obtenerIndicadoresPropuestas();
      if (response.status === 200 && response.data) {
        setIndicadores(response.data);
      }
    } catch (error) {
      console.error('Error al cargar indicadores:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="text-center py-5"><Spinner animation="border" /></div>;
  if (!indicadores) return <div className="text-center py-5 text-muted">Sin datos disponibles</div>;

  const porEstado = indicadores.por_estado || [];
  const labels = porEstado.map(e => e._id);
  const counts = porEstado.map(e => e.count);
  const colors = labels.map(l => ESTADO_COLORS[l] || '#999');

  const barData = {
    labels,
    datasets: [{
      label: 'Propuestas',
      data: counts,
      backgroundColor: colors,
      borderRadius: 4
    }]
  };

  const pieData = {
    labels,
    datasets: [{
      data: porEstado.map(e => e.valor || e.count),
      backgroundColor: colors
    }]
  };

  return (
    <div className="container-fluid py-4">
      <h4 className="mb-3">Dashboard de Propuestas</h4>
      <Row>
        <Col md={3}>
          <Card className="text-center">
            <Card.Body>
              <h3 className="text-primary">{indicadores.totales?.total_propuestas || 0}</h3>
              <p className="text-muted mb-0">Total Propuestas</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="text-center">
            <Card.Body>
              <h3 className="text-success">
                ${(indicadores.totales?.valor_total || 0).toLocaleString('es-CO')}
              </h3>
              <p className="text-muted mb-0">Valor Total</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="text-center">
            <Card.Body>
              <h3 className="text-info">{indicadores.tasa_conversion || 0}%</h3>
              <p className="text-muted mb-0">Tasa de Conversión</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="text-center">
            <Card.Body>
              <h3 className="text-warning">
                {porEstado.find(e => e._id === 'aprobada')?.count || 0}
              </h3>
              <p className="text-muted mb-0">Aprobadas</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col md={6}>
          <Card>
            <Card.Header>Propuestas por Estado</Card.Header>
            <Card.Body>
              {porEstado.length > 0 ? (
                <Bar data={barData} options={{ responsive: true, plugins: { legend: { display: false } } }} />
              ) : (
                <p className="text-muted text-center">Sin datos</p>
              )}
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card>
            <Card.Header>Distribución por Estado</Card.Header>
            <Card.Body>
              {porEstado.length > 0 ? (
                <Pie data={pieData} options={{ responsive: true }} />
              ) : (
                <p className="text-muted text-center">Sin datos</p>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default DashboardPropuestas;